import { Component, Input, EventEmitter, Output } from '@angular/core';
import { ModuleConfigService } from 'src/app/common/services/module-config/module-config.service';

import { EclSummary } from 'src/app/ecl/models/ecl-summary';

@Component({
  selector: 'app-ocl-summary',
  templateUrl: './ocl-summary.component.html',
  styleUrls: ['./ocl-summary.component.scss'],
})
export class OclSummaryComponent {
  @Input() summary: EclSummary;
  @Input() isInSummary;
  @Input() isInBriefing;
  @Input() invertedStyle = false;
  @Input() isReadOnly = false;

  @Output() isInSummaryChange = new EventEmitter();
  @Output() isInBriefingChange = new EventEmitter();

  constructor(public moduleConfig: ModuleConfigService) {}

  public onClick(type: 'isInSummary' | 'isInBriefing') {
    this[`${type}`] = !this[`${type}`];
    this[`${type}Change`].emit(this[`${type}`]);
    if (type === 'isInSummary' && this[`${type}`] === false) {
      this.isInBriefingChange.emit(false);
    }
  }
}
